import { render, staticRenderFns } from "./AbstractEntity.vue?vue&type=template&id=577f65ef"
import script from "./AbstractEntity.vue?vue&type=script&lang=js"
export * from "./AbstractEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports